<span class="cui-toast__message">{{ message() }}</span>
<button
  cuiButton
  square
  size="small"
  variant="plain"
  type="button"
  aria-label="Dismiss notification"
  (click)="dismiss.emit()">
  <span class="material-symbols-outlined" aria-hidden="true">close</span>
</button>
